import React from 'react';

import { Spinner } from 'app/design-system/components/Spinner';

import { TelegramButton } from './TelegramButton';
import { useTelegramSign } from './useTelegramSign';

import styles from './TelegramSign.module.scss';

export type TelegramSignProps = {
  processing?: boolean;
  onProcessing?: () => void;
  onFail?: () => void;
  onSuccess?: () => void;
  className?: string;
};

export const TelegramSign = ({
  className,
  processing,
  onProcessing,
  onFail,
  onSuccess,
}:
  TelegramSignProps) => {
  const { url, status, loading, start } = useTelegramSign({ onSuccess, onProcessing, onFail });

  const handleClick = () => {
    onProcessing?.();
    start();
  };

  if (status === 'FAILED_LOAD_CONFIG') {
    return null;
  }

  if (loading) {
    return (
      <Spinner size={24}
               className={styles.spinner} />
    );
  }

  return (
    <TelegramButton className={className}
                    loading={processing}
                    url={url}
                    onClick={handleClick} />
  );
};
